import BasicLayout from '@/layouts/basic-layout';
var pre = 'canteen-';
export default {
  path: '/canteen',
  name: 'canteen',
  redirect: {
    name: "".concat(pre, "front")
  },
  meta: {
    auth: ['canteen-manage'],
    title: '食堂管理'
  },
  component: BasicLayout,
  children: [{
    path: 'front',
    name: "".concat(pre, "front"),
    meta: {
      auth: ['canteen-front'],
      title: '食堂前台'
    },
    component: function component() {
      return import('@/pages/canteen/front');
    }
  }, {
    path: 'dish',
    name: "".concat(pre, "dish"),
    meta: {
      auth: ['canteen-dish'],
      title: '菜品管理'
    },
    component: function component() {
      return import('@/pages/canteen/dish');
    }
  }, {
    path: 'menu',
    name: "".concat(pre, "menu"),
    meta: {
      auth: ['canteen-menu'],
      title: '菜单管理'
    },
    component: function component() {
      return import('@/pages/canteen/menu');
    }
  }, {
    path: 'price',
    name: "".concat(pre, "price"),
    meta: {
      auth: ['canteen-price'],
      title: '计价设置'
    },
    component: function component() {
      return import('@/pages/canteen/price');
    }
  }, {
    path: 'recharge',
    name: "".concat(pre, "recharge"),
    meta: {
      auth: ['canteen-recharge'],
      title: '余额充值'
    },
    component: function component() {
      return import('@/pages/canteen/recharge');
    }
  }, {
    path: 'coupon',
    name: "".concat(pre, "coupon"),
    meta: {
      auth: ['canteen-coupon'],
      title: '折扣券'
    },
    component: function component() {
      return import('@/pages/canteen/coupon');
    }
  }, {
    path: 'weigh',
    name: "".concat(pre, "weigh"),
    meta: {
      auth: ['canteen-weigh'],
      title: '称重计价'
    },
    component: function component() {
      return import('@/pages/canteen/weigh');
    }
  }, {
    path: 'bills',
    name: "".concat(pre, "bills"),
    meta: {
      auth: ['canteen-bill'],
      title: '订单账单'
    },
    component: function component() {
      return import('@/pages/canteen/bills');
    }
  }]
};